import Vue from 'vue'

import CommonUtil from '../utils/global-util'

Vue.prototype.$utils = CommonUtil;           //注册全局方法